<div [class.sched-select-tight]="isTight" [title]="currentSchedTooltip">
    <ng-select
        #ngSelect
        class="schedule-select ng-select-prefix-icon"
        [items]="scheduleOptions"
        [placeholder]="selectedScheduleName || 'Select schedule...'"
        [clearable]="true"
        [searchable]="true"
        (change)="onChangeSchedule($event)"
        [(ngModel)]="scheduleId"
        appendTo=".auto-width-ng-select"
        bindValue="scheduleId"
        bindLabel="name"
        [searchFn]="schedSearchFn"
        [loading]="isLoading"
        [disabled]="isDisabled"
    >
        <ng-template ng-option-tmp let-item="item">
            <div class="sched-opt-row" [class.tight-opt-row]="isTight">
                <div>
                    <div class="sched-name" [title]="item.name">{{ item.name }}</div>
                    <div class="sched-desc" [title]="item.scheduleDesc">
                        <span
                            class="sched-active-state"
                            title="This schedule is {{ item.isActive ? 'active' : 'not active' }}"
                        >
                            <cdp-active-status-display [isActive]="item.isActive"></cdp-active-status-display>
                        </span>
                        <span
                            class="sched-job-count"
                            title="{{ item.ingestionJobCount }} job(s) on this schedule currently"
                        >
                            {{ item.ingestionJobCount || 0 }}<span class="icon-right icon-toolbox"></span>
                        </span>
                        {{ item.scheduleDesc }}
                    </div>
                </div>
                @if (tenantId && hasSourcesEditPermission && !isDisabled) {
                    <a
                        hc-button
                        buttonStyle="{{ isTight ? 'minimal' : 'link-inline' }}"
                        href="/tenant/{{ tenantId }}/schedules/{{ item.scheduleId }}"
                        (click)="$event.stopPropagation()"
                        target="{{ isTight ? '_blank' : '_self' }}"
                        title="Navigate to this schedule"
                        [class.cdp-simple-ico-btn]="isTight"
                    >
                        @if (!isTight) {
                            <span>Go to schedule</span>
                        }
                        <span class="icon-right {{ isTight ? 'icon-external-link' : 'icon-chev-right' }}"></span>
                    </a>
                }
            </div>
        </ng-template>
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <div
                class="schedule-selected-row"
                title="({{ item.isActive ? 'Active' : 'Inactive' }}) {{ item.name }}"
                [class.inactive-sched]="!item.isActive"
            >
                @if (isInactiveScheduleSelected && showInactiveWarningAsIcon) {
                    <span
                        class="icon-warn icon-left inactive-sched-warning-ico"
                        [hcTooltip]="inactiveScheduleWarning"
                    ></span>
                }
                <span
                    class="{{
                        isSelectedScheduleActive(item) ? 'icon-status-success' : 'icon-status-cancelled'
                    }} status-ico"
                ></span
                ><span>{{ getSelectedScheduleName(item) }}</span>
            </div>
        </ng-template>
        <ng-template ng-footer-tmp *ngIf="showNewSchedBtn">
            <button hc-button buttonStyle="link-inline" (click)="createNewSched()" class="new-sched-button">
                + <span class="icon-calendar-clock icon-left icon-right"></span>Create new schedule
            </button>
        </ng-template>
    </ng-select>
</div>
@if (isInactiveScheduleSelected && !showInactiveWarningAsIcon) {
    <div class="cdp-warn-chip-container">
        <hc-chip color="yellow" width="100%">
            <div class="cdp-warn-message-container">
                <span class="icon-warn"></span>
                <span>{{ inactiveScheduleWarning }}</span>
            </div>
        </hc-chip>
    </div>
}
